import { Link } from 'react-router-dom';
import SuccessMessage from '../components/success-message';

interface IProps {
  message: string;
}

const AgencyRegisterSuccess: React.FC<IProps> = ({ message }) => {
  return (
    <div>
      <SuccessMessage message={message} type="success" />
      <Link to="/">
        <button className="w-full text-white px-5 py-2 rounded-lg bg-[#1D8A43] disabled:opacity-20">
          Go to Homepage
        </button>
      </Link>
    </div>
  );
};

export default AgencyRegisterSuccess;
